import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { GlobalLoadingScreenComponent } from './global-loading-screen.component';
import { LoadingScreenComponent } from './loading-screen.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingIndicatorInterceptor } from '../../services/loading-indicator.interceptor';

@NgModule({
  declarations: [LoadingScreenComponent, GlobalLoadingScreenComponent],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [LoadingScreenComponent, GlobalLoadingScreenComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingIndicatorInterceptor,
      multi: true,
    },
  ],
})
export class LoadingScreenModule {}
